import { useAuth } from '@/context/AuthContext';
import { Navigate } from 'react-router-dom';
import { Plane } from 'lucide-react';

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#EFF2F7] flex items-center justify-center">
        <div className="flex flex-col items-center gap-4 animate-fade-in">
          <div className="w-12 h-12 rounded-2xl bg-[#3A86FF] flex items-center justify-center animate-pulse shadow-lg shadow-blue-500/20">
            <Plane className="w-6 h-6 text-white" strokeWidth={2} />
          </div>
          <p className="text-sm text-[#94A3B8]">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  return children;
};
